
import React from 'react';
const StudentAssessment =()=>{
    return(
        <>
            Student Assessment
        </>
    )
}
export default StudentAssessment